import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { isOverflowed } from "./utils";
import { Tooltip } from "../../../../Tooltip";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var CharacteristicsSection = function CharacteristicsSection(_ref) {
  var _device$characteristi, _device$characteristi2;
  var size = _ref.size,
    device = _ref.device;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    hashValues = _useState2[0],
    setHashValues = _useState2[1];
  var refs = useRef([]);
  useEffect(function () {
    // хак с setTimeout требуется для обращения к ref в useEffect
    setTimeout(function () {
      if ((refs === null || refs === void 0 ? void 0 : refs.current.length) > 0) {
        var hash = {};
        var _iterator = _createForOfIteratorHelper(refs.current),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var ref = _step.value;
            hash[ref === null || ref === void 0 ? void 0 : ref.textContent] = isOverflowed(ref);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        setHashValues(hash);
      }
    }, 0);
  }, []);
  // если есть промо, то характеристики не показывать
  var shouldShowCharacteristics = !!(device !== null && device !== void 0 && (_device$characteristi = device.characteristics) !== null && _device$characteristi !== void 0 && _device$characteristi.length) && !(device !== null && device !== void 0 && device.promoBundle) && !(device !== null && device !== void 0 && device.promoCredit);
  var characteristics = (_device$characteristi2 = device === null || device === void 0 ? void 0 : device.characteristics) !== null && _device$characteristi2 !== void 0 ? _device$characteristi2 : [];
  return shouldShowCharacteristics ? /*#__PURE__*/React.createElement("div", {
    className: cx('section', size && "section--".concat(size)),
    id: "containerss"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('caption')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-l"
  }, "\u0425\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438")), /*#__PURE__*/React.createElement("ul", {
    className: cx('list')
  }, characteristics.slice(0, 4).map(function (characteristic) {
    return /*#__PURE__*/React.createElement("li", {
      className: cx('wrapper'),
      key: characteristic.value
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('label')
    }, /*#__PURE__*/React.createElement(Text, {
      color: "grey50",
      size: "size6-m"
    }, characteristic.label)), /*#__PURE__*/React.createElement("div", {
      className: cx('value'),
      ref: function ref(_ref2) {
        refs.current.push(_ref2);
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size6-m"
    }, characteristic.value)), /*#__PURE__*/React.createElement(Tooltip, {
      help: characteristic.value,
      isTooltip: hashValues[characteristic.value]
    }));
  }))) : null;
};